import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Learnspace } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { IntercomTags, InternalAnalyticsService } from '@shared/services/internalAnalytics.service';

@Component({
  selector: 'hub-community-list',
  templateUrl: './hub-community-list.component.html',
  styleUrls: ['./hub-community-list.component.scss']
})
export class HubCommunityListComponent implements OnInit {
  learnspaces: Learnspace[] = [];
  canAddProgram = false;
  isLoading = true;
  isRemixing = false;
  skeletonItems = Array(3);
  @Output() cardClicked = new EventEmitter<Learnspace>();

  constructor(
    private _http: HttpClient,
    private _courseApiService: CoursesAPIService,
    private _currentHubService: CurrentHubService,
    private _router: Router,
    private _internalAnalitycsService: InternalAnalyticsService
  ) {}

  ngOnInit(): void {
    this.canAddProgram = this._currentHubService.canManageCurrentHub();
    this.getCommunityPrograms();
    this._currentHubService.refreshCanCreateSpace();
  }

  canCreateSpace(): boolean {
    return this._currentHubService.canCreateSpace;
  }

  async getCommunityPrograms(): Promise<void> {
    try {
      const data: any = await this._http.get(environment.fromTheCommunityListFile).toPromise();
      const learnspaces_ids = data.templates.map((t: any) => t.program_id);
      const learnspaces = await Promise.all(learnspaces_ids.map((id: string) => this._courseApiService.getLearnspaceById(id).toPromise()));
      this.learnspaces = learnspaces.filter(Boolean);
    } catch {
      this.learnspaces = [];
    } finally {
      this.isLoading = false;
    }
  }

  async remixProgram(ls: Learnspace): Promise<void> {
    if (this.isRemixing) return;
    this.isRemixing = true;
    try {
      const newProgram = await this._courseApiService.duplicateLearnspace(ls.id, this._currentHubService.hub.id).toPromise();
      this._internalAnalitycsService.addIntercomUserTag(IntercomTags.WONDA_PRO_HAS_CREATED_PROGRAM);
      await this._currentHubService.refreshCanCreateSpace();
      this._router.navigate([`${this._currentHubService.getHubURLTitle()}/${newProgram.id}`]);
    } finally {
      this.isRemixing = false;
    }
  }
}
